import UseImage from "./user_medal.png";
import LogoImage from "./logo.svg";
import Res1 from "./res1.png";
import Res2 from "./res2.png";
import Res3 from "./res3.png";
import Res4 from "./res4.png";
import Res5 from "./res5.png";
import VideoImg from "./video_img.png";
import FreeVideoImg from "./freeV_img.png";
import Concept from "./concept_img.png";
import QbBanner from "./qb_banner_img.png";
import Qbmark from "./qb_mark.png";
import NoDataFound from "./nodatafound.webp";
import AnsImg from "./ans_img.png";
import Menu from "./menu.png";
import Cross from "./cross.png";
import User from "./user.png";
import Package from "./package.png";
import BgSignup from "./bg_signup.png";
import LoginImg from "./login_img.png";
import Google from "./Google.png";
import LoginImg2 from "./login_img2.png";
import LoginImg3 from "./login_img3.png";
import Globe from "./globe.png";
import NoDataImg from "./no_data_found.png";
import NoData from "./no_data_found.png";
import Success from "./success.png";
import Error from "./error.png";
import Pending from "./pending.png";
import Call from "./call.png";
import Whatsapp from "./whatsapp.png";
import Msg from "./msg.png";
import defaultImg from "./defaultImg.png";
import defaultVideo from './defaultVideo.png'
import Gold from "./gold.png";
import Silver from "./silver.png";
import Bronze from "./bronze.png";
import VideopopupImg from "./videopopupImg.png";
import Blank_Qb from "./blank_qb.png";
import LeftType from "./left_type.png";
import RightType from "./right_type.png";
import AnsweredMarked from "./answered_marked.png";
import Warning from "./warning.png";



const Images = {
    UseImage,
    LogoImage,
    Res1,
    Res2,
    Res3,
    Res4,
    Res5,
    NoDataFound,
    NoData,
    VideoImg,
    FreeVideoImg,
    Concept,
    QbBanner,
    Qbmark,
    AnsImg,
    Menu,
    Cross,
    User,
    Package,
    BgSignup,
    LoginImg,
    Google,
    LoginImg2,
    LoginImg3,
    Globe,
    NoDataImg,
    Success,
    Error,
    Pending,
    Call,
    Whatsapp,
    Msg,
    defaultImg,
    defaultVideo,
    Gold,
    Silver,
    Bronze,
    VideopopupImg,
    Blank_Qb,
    LeftType,
    RightType,
    AnsweredMarked,
    Warning
}
export default Images;